// Modules
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MaterialModule } from '../core/material.module';

// Services
import { SurveyService } from './Services/survey.service';

// Components
import { SurveyListComponent } from './Components/survey-list/survey-list.component';
import { SurveyCreateComponent } from './Components/survey-create/survey-create.component';
import { SurveyEditComponent } from './Components/survey-edit/survey-edit.component';
import { SurveyQuestionComponent } from './Components/survey-question/survey-question.component';

@NgModule({
    declarations: [
        SurveyListComponent, SurveyCreateComponent, SurveyEditComponent,
        SurveyQuestionComponent
    ],
    entryComponents: [SurveyQuestionComponent],
    imports: [
        CommonModule, RouterModule, FormsModule, ReactiveFormsModule, MaterialModule
    ],
    providers: [SurveyService]
})

export class SurveyModule {}